import { Box, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../../../theme";

interface ActivityLog {
  date: string;
  status: string;
  by: string;
}

interface ActivityLogTableProps {
  logs: ActivityLog[];
  lastUpdated?: { date: string; by: string };
}

export default function ActivityLogTable({
  logs,
  lastUpdated,
}: ActivityLogTableProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Paper sx={{ borderRadius: "14px", boxShadow: 0, overflow: "hidden" }}>
      {/* Header */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          bgcolor: "background.paper",
          px: 2,
          py: 1.2,
          borderBottom: `1px solid ${colors.primary[800]}`,
        }}
      >
        {["DATE", "STATUS", "BY"].map((col) => (
          <Typography
            key={col}
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color: colors.primary[700],
              letterSpacing: 0.5,
            }}
          >
            {col}
          </Typography>
        ))}
      </Box>

      {/* Rows */}
      {logs.length === 0 ? (
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontSize: "12px", color: colors.primary[800] }}>
            No activity yet
          </Typography>
        </Box>
      ) : (
        logs.map((log, index) => (
          <Box
            key={index}
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              px: 2,
              py: 1.5,
              borderBottom:
                index < logs.length - 1
                  ? `1px solid ${colors.primary[800]}`
                  : "none",
            }}
          >
            <Typography sx={{ fontSize: "12px", color: colors.primary[100] }}>
              {log.date}
            </Typography>
            <Typography sx={{ fontSize: "12px", color: colors.primary[100] }}>
              {log.status}
            </Typography>
            <Typography sx={{ fontSize: "12px", color: colors.primary[100] }}>
              {log.by}
            </Typography>
          </Box>
        ))
      )}
      {lastUpdated && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            px: 2,
            py: 1,
            borderTop: `1px solid ${colors.primary[800]}`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              bgcolor: "background.paper",
              borderRadius: "20px",
              px: 1.5,
              py: 0.5,
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 700,
                color: "text.secondary",
              }}
            >
              LAST UPDATED
            </Typography>
            <Typography sx={{ fontSize: "10px", color: colors.primary[700] }}>
              {lastUpdated.date} by {lastUpdated.by}
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
}
